import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const FullscreenCloseIcon: React.FC<OneColorIconProps> = ({ className, color = 'core-gray-100', size = 20 }) => {
  const hex = getHexColor(color)

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 9C8.55229 9 9 8.55229 9 8L9 1C9 0.447716 8.55228 0 8 0C7.44771 0 7 0.447716 7 1L7 7L1 7C0.447716 7 0 7.44772 0 8C0 8.55229 0.447716 9 1 9L8 9ZM12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H12Z"
        fill={hex}
      />
    </svg>
  )
}
